import { HandoffPaymentReview } from '../components/HandoffPaymentReview';

/** Routable review queue for sales payment evidence sent to Dispatch. */
export function HandoffPaymentReviewPage() {
  return <HandoffPaymentReview />;
}
